import EngineJson from "./engineJson";

export default class Engine {
  code: string | null;
  fuelType: string | null;
  horsepower: string | null;
  name: string | null;
  number: string | null;
  numberOfCylinders: string | null;

  constructor() {
    this.code = null;
    this.fuelType = null;
    this.horsepower = null;
    this.name = null;
    this.number = null;
    this.numberOfCylinders = null;
  }

  static fromJSON(json: EngineJson | null): Engine {
    const engine = new Engine();

    if (json === null) {
      return engine;
    }

    engine.code = json.code;
    engine.fuelType = json.fuelType;
    engine.horsepower = json.horsepower;
    engine.name = json.name;
    engine.number = json.number;
    engine.numberOfCylinders = json.numberOfCylinders;

    return engine;
  }
}
